export default () => ({
    border: `1px solid transparent`,
    width: `240px`,
    height: `32px`,
    marginTop: `16px`,
    padding: `0 12px`,
    borderRadius: `3px`,
    boxShadow: `0 2px 6px rgba(0, 0, 0, 0.3)`,
    fontSize: `14px`,
    textOverflow: `ellipses`,
});
